import axios from 'axios'
import { Message } from 'view-design'
import router from '@/router'
import { showLoading, closeLoading } from '@/utils/loading'
import { resetTokenAndClearUser } from '@/utils'

const service = axios.create({
    baseURL: window.location.origin,
    timeout: 60000,
})

service.interceptors.request.use(config => {
    // showLoading()
    if (localStorage.getItem('token')) {
        config.headers.token = localStorage.getItem('token')
    }
    config.headers["If-Modified-Since"] = "0"
    config.headers["Cache-Control"] = "no-cache"
    return config
}, (error) => Promise.reject(error))

service.interceptors.response.use(response => {
    closeLoading()
    // if(!localStorage.getItem('token')){
    //     resetTokenAndClearUser()
    //     router.push('/login')
    // }
    const res = response.data
    // 这里是接口处理的一个示范，可以根据自己的项目需求更改
    // 错误处理
    if (res.code == 0 && res.msg) {
        Message.error({
            content: res.msg,
        })
        return Promise.reject()
    }

    // 如果接口正常，直接返回数据
    return res
}, (error) => {
    closeLoading()
    const errorString = error.toString()
    if(errorString.indexOf('401')){
        resetTokenAndClearUser()
        Message.error({
            content: '登录状态失效，请重新登录',
        })
        setTimeout(() => {
            router.push('/login')
        }, 500);
        return 
    }
    Message.error({
        content: error.message || '系统异常，请联系管理员',
    })
    return Promise.reject(error)
})

export default service
